import React from 'react';

const Logo = ({ size = 'default', showDomain = true }) => {
  const sizes = {
    small: { icon: 28, text: 16, domain: 10 },
    default: { icon: 34, text: 20, domain: 12 },
    large: { icon: 42, text: 26, domain: 15 },
  };

  const s = sizes[size] || sizes.default;

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 9 }}>
      <svg
        width={s.icon}
        height={s.icon}
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="40" height="40" rx="10" fill="#2F3A8F" />

        {/* Briefcase body */}
        <rect x="8" y="15" width="24" height="16" rx="3" stroke="#fff" strokeWidth="2.2" fill="none" />
        {/* Briefcase handle */}
        <path d="M15 15V12a3 3 0 013-3h4a3 3 0 013 3v3" stroke="#fff" strokeWidth="2.2" fill="none" strokeLinecap="round" />
        {/* Briefcase center line */}
        <line x1="8" y1="21" x2="32" y2="21" stroke="#fff" strokeWidth="1.5" opacity="0.4" />

        {/* AI sparkle - 4 point star */}
        <path
          d="M20 18.5 L21 20.8 L23.5 21.5 L21 22.2 L20 24.5 L19 22.2 L16.5 21.5 L19 20.8 Z"
          fill="#fff"
        />
        {/* Small sparkle top-right */}
        <path
          d="M28 11 L28.5 12.2 L29.8 12.5 L28.5 12.8 L28 14 L27.5 12.8 L26.2 12.5 L27.5 12.2 Z"
          fill="#fff"
          opacity="0.6"
        />
      </svg>
      <span style={{
        fontSize: s.text,
        fontWeight: 800,
        letterSpacing: '-0.3px',
        color: '#1F2937',
        lineHeight: 1,
        fontFamily: "'Inter', sans-serif",
      }}>
        is
        <span style={{ color: '#2F3A8F' }}>Bulsun</span>
        {showDomain && (
          <span style={{
            fontSize: s.domain,
            fontWeight: 300,
            color: 'rgba(31,41,55,0.25)',
            letterSpacing: '0.5px',
          }}>.com</span>
        )}
      </span>
    </div>
  );
};

export default Logo;
